import { bl_fi_budget_category_RowClass } from '../../../dbschema/bl_fi_budget_category.model';
import { BaseContainerModel } from '../../base-container.model';


export class BudgetCategoryContainerModel extends BaseContainerModel {
    bl_fi_budget_category: bl_fi_budget_category_RowClass = new bl_fi_budget_category_RowClass();
}
